const initMenu = (buttons) => {
    const body = document.querySelector('.js-body');

    const menuClass = 'menu-open';
    const exploreClass = 'explore-open';
    const searchClass = 'search-open';
    const stopScrolling = 'stop-scrolling';

    window.menuOpen = false;
    window.exploreOpen = false;
    window.searchOpen = false;

    document.body.addEventListener('click', (event) => {
        // If toggle button clicked
        if ([...buttons].includes(event.target)) {
            event.preventDefault();

            const button = event.target;

            if (button.classList.contains('js-menu-toggle')) {
                window.menuOpen = !window.menuOpen;

                if (window.menuOpen) {
                    body.classList.add(menuClass);

                    if (window.searchOpen) {
                        window.searchOpen = false;
                        body.classList.remove(searchClass, stopScrolling);
                    }
                } else {
                    body.classList.remove(menuClass);

                    if (window.exploreOpen) {
                        window.exploreOpen = false;
                        body.classList.remove(exploreClass, stopScrolling);
                    }
                }
            }

            if (button.classList.contains('js-explore-toggle')) {
                window.exploreOpen = !window.exploreOpen;

                if (window.exploreOpen) {
                    body.classList.add(exploreClass, stopScrolling);

                    if (window.searchOpen) {
                        window.searchOpen = false;
                        body.classList.remove(searchClass);
                    }
                } else {
                    body.classList.remove(exploreClass, stopScrolling);
                }
            }

            if (button.classList.contains('js-search-toggle')) {
                const searchInput = document.querySelector('.js-search-input');
                window.searchOpen = !window.searchOpen;

                if (window.searchOpen) {
                    searchInput.focus();
                    body.classList.add(searchClass, stopScrolling);

                    // Close other elements
                    if (window.menuOpen) {
                        window.menuOpen = false;
                        body.classList.remove(menuClass);
                    }

                    if (window.exploreOpen) {
                        window.exploreOpen = false;
                        body.classList.remove(exploreClass);
                    }
                } else {
                    searchInput.blur();
                    body.classList.remove(searchClass, stopScrolling);
                }
            }

            if (button.classList.contains('js-sub-menu-toggle')) {
                const submenu = button.nextElementSibling;

                if (submenu) {
                    const styles = window.getComputedStyle(submenu);

                    // Flip button and show/hide sub menu on click
                    if (styles.display === 'block') {
                        submenu.style.display = 'none';
                        button.style.transform = 'rotate(0deg)';
                    } else {
                        submenu.style.display = 'block';
                        button.style.transform = 'rotate(180deg)';
                    }
                }
            }
        }

        // Hide explore and search if shadow element clicked
        if (event.target.classList.contains('js-toggle-shadow')) {
            event.preventDefault();
            window.exploreOpen = false;
            window.searchOpen = false;

            body.classList.remove(exploreClass);
            body.classList.remove(searchClass);
            body.classList.remove(stopScrolling);
        }
    });
};

export { initMenu as default };
